import { Input, Tree as TreeAntd } from 'antd';
import styled from 'styled-components';

export const Tree = styled(TreeAntd)`
  height: 300px;
  overflow-y: auto;

  .panorama-tree-switcher {
    width: 10px;
  }

  .panorama-tree-switcher-leaf-line {
    display: none;
  }
`;

export const Search = styled(Input.Search)`
  margin-bottom: 8px;
`;
